import {ActivatedRoute,NavigationEnd,Router} from '@angular/router';
import {filter,map} from 'rxjs/operators';
import {merge,Observable,of} from 'rxjs';

/**
 * Permet de gérer la route courante et le refresh
 * Retourne un Observable des params de la route lors des navigations
 */
export function watchRouteParams(router: Router,activatedRoute: ActivatedRoute): Observable<any> {
    //Observable de la route courante, gère le refresh
    const initialParams$ = of(activatedRoute.snapshot.params);

    //Observable qui écoute NavigationEnd puis récupère les params de la route active, gère le cas normal
    const navigationParams$ = router.events.pipe(
        filter(e => e instanceof NavigationEnd),
        map(() => {
            return activatedRoute.snapshot.params;
        })
    );

    return merge(initialParams$,navigationParams$);
}